import axios from 'axios';
import Cookies from 'js-cookie';

const refreshURL = `${process.env.REACT_APP_PUBLIC_BASE_URL}/api/refresh_token`;

let refreshPromise = null;

export const getCookies = () => {
  const token = Cookies.get('token', {
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });

  const refreshToken = Cookies.get('refresh_token', {
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });

  const xSwitchUser = Cookies.get('xSwitchUser', {
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });

  return { token, refreshToken, xSwitchUser };
};

export const setCookies = (token, refreshToken) => {
  Cookies.set('token', token, {
    expires: 1,
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });

  Cookies.set('refresh_token', refreshToken, {
    expires: 1,
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });
};

/**
 * Single refresh entry point for both the RTK Query and the axios pipelines. Each refresh
 * rotates `User.hash` on the BE (one account = one session), so concurrent refreshes would
 * invalidate each other's tokens:
 * - callers share one in-flight request;
 * - a 401 for `staleToken` after the cookie already holds a newer token (late response,
 *   another tab refreshed) reuses that token instead of refreshing again.
 * Resolves with the access token to retry with; rejects with the axios error if refresh fails.
 */
export const refreshTokens = (staleToken) => {
  const { token, refreshToken } = getCookies();

  if (refreshPromise) {
    return refreshPromise;
  }

  if (token && token !== staleToken) {
    return Promise.resolve(token);
  }

  refreshPromise = axios
    .post(refreshURL, { refreshToken })
    .then(({ data }) => {
      setCookies(data.token, data.refreshToken);
      return data.token;
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
};

export const removeCookies = () => {
  Cookies.remove('token', {
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });
  Cookies.remove('refresh_token', {
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });
};

export const switchUser = () => {
  Cookies.remove('xSwitchUser', {
    domain: process.env.REACT_APP_COKKIE_URL,
    path: '/',
  });
};
